export const GenericErrorPageConstants = {
  PageTitle: 'Sorry, something went wrong',
  PageParagraph: 'An unexpected error has occurred.',
  ButtonLabel: 'Start again',
} as const
